<template>
  <div class="container" v-if="path.length">
    <div
      class="col-lg-12 d-flex justify-content-center mb-2 m-top"
      @click="redirectBanner(sorteado.url)"
    >
      <img
        :src="sorteado.image"
        :alt="translate.subscribe"
        width="1012"
        height="124"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import translateMain from "@/tradutors/menu";
const props = defineProps(["path"]);
const  route = useRoute();
const translate = computed(() =>
  route.params.language === "pt-br"
    ? translateMain.portugues
    : translateMain.ingles
);

const sorteado = ref({ image: "", url: "" });
watch(
  () => props.path,
  () => {
    sorteado.value = numeroAleatorioAteN();
  }
);

onMounted(() => {
  if (props.path.length) sorteado.value = numeroAleatorioAteN();
});

function numeroAleatorioAteN() {
  const numeroSorteado = Math.floor(Math.random() * props.path.length);
  return props.path[numeroSorteado];
}
function redirectBanner(url: string) {
  window.location.href = url;
}
</script>
<style scoped lang="css">
img {
  width: 1012px;
  height: 124px;
  cursor: pointer;
}

@media screen and (max-width: 992px) {
  img {
    width: 95%;
    cursor: pointer;
    object-fit: cover;
    height: auto;
  }
}
</style>
